import { render, staticRenderFns } from "./RelationshipsEditor.vue?vue&type=template&id=4525644a&"
import script from "./RelationshipsEditor.vue?vue&type=script&lang=js&"
export * from "./RelationshipsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports